export const th = {
    "n1": "หน้าแรก",
    "n2": "สั่งซื้อ",
    "n3": "การทำธุรกรรม",
    "n4": "ทีม",
    "n5": "ของฉัน",
    "t1": "มีบางอย่างผิดพลาด",
    "t2": "คัดลอกเรียบร้อยแล้ว",
    "t3": "กรุณากรอกข้อมูลให้ครบถ้วน",
    "t4": "กำลังโหลด...",
    "t5": "เข้าสู่ระบบสำเร็จ",
    "t6": "คะแนนต้องมากกว่า 3 จึงจะส่งได้",
    "t7": "ส่งสำเร็จแล้ว",
    "t8": "ยอดคงเหลือไม่เพียงพอ ไม่สามารถรับได้",
    "t9": "การส่งล้มเหลว",
    "t10": "กรุณาผูกที่อยู่ก่อน แล้วคุณจะถูกเปลี่ยนเส้นทางไปยังหน้าศูนย์ส่วนบุคคล",
    "t11": "ที่อยู่ถูกผูกไว้โปรดติดต่อฝ่ายบริการลูกค้าเพื่อแก้ไข",
    "t12": "การปรับเปลี่ยนสำเร็จ",
    "t13": "การแก้ไขล้มเหลว",
    "t14": "โปรดติดต่อฝ่ายบริการลูกค้าเพื่อเปลี่ยนรหัสผ่านของคุณ",
    "t15": "ข้อผิดพลาดรูปแบบรหัสผ่าน",
    "t16": "ถอนเงินสำเร็จ",
    "t17": "จำนวนเงินสูงสุดที่สามารถถอนออกได้",
    "t18": "การถอนขั้นต่ำ",
    "t19": "รหัสผ่านสองตัวไม่สอดคล้องกัน",
    "t20": "เคล็ดลับ",
    "t21": "ไม่สามารถกระโดดได้ในขณะนี้",
    "t22": "ข้อผิดพลาดรูปแบบรหัสผ่าน",
    "t23": "การลงทะเบียนสำเร็จ",
    "t24": "กรุณากรอกรหัสพื้นที่",
    "t25": "ไม่มีอีกแล้ว",
    "l1": "ภาษา",
    "l2": "กรุณากรอกหมายเลขบัญชี",
    "l3": "กรุณากรอกรหัสผ่าน",
    "l4": "จำไว้",
    "l5": "เข้าสู่ระบบ",
    "l6": "ไปลงทะเบียน",
    "l7": "ไม่มีบัญชี",
    "l8": "หมายเลขโทรศัพท์มือถือ",
    "l9": "ชื่อเล่น",
    "l10": "รหัสผ่าน",
    "l11": "ยืนยันรหัสผ่าน",
    "l12": "รหัสคำเชิญ",
    "l13": "ลงทะเบียน",
    "l14": "มีบัญชีอยู่แล้ว",
    "l15": "ไปที่เข้าสู่ระบบ",
    "l16": "กรุณากรอกรหัสผ่าน 6-16 หลัก",
    "bz1": "ช่วยด้วย",
    "bz2": "คำถามที่พบบ่อย",
    "bz3": "กฎการซื้อขาย",
    "bz4": "วิธีการถอนเงิน",
    "bz5": "วิธีการเติมเงิน",
    "bz6": "1. Amazon Review RoBoT คืออะไร",
    "bz7": "Amazon Review RoBoT คือบริษัทส่งเสริมการตลาดที่ช่วยให้ผู้ค้าร้านค้าออนไลน์ของ Amazon Review RoBoT ทั่วโลกได้รับคำสั่งซื้อเพิ่มขึ้น และเพิ่มข้อมูลการเรียกดูร้านค้าออนไลน์ของ Amazon Review RoBoT เรามุ่งมั่นที่จะสร้างโมเดลการตลาดและการส่งเสริมการขายที่ทำกำไรจากบุคคลที่สามระหว่าง Amazon Review RoBoT ผู้ค้า และผู้บริโภค เมื่อรวมกับเทคโนโลยีบล็อคเชน P2P ล่าสุด ผู้บริโภคและผู้ค้าจะเชื่อมต่อกันอย่างรวดเร็วผ่าน USDT (TRC20, ERC20) ผู้ใช้ที่ลงทะเบียนสามารถรับค่าคอมมิชชั่นจากการสั่งซื้อ ในขณะที่ร้านค้าสามารถเพิ่มข้อมูลยอดขายของร้านค้าได้ มันเป็นรูปแบบกำไรล่าสุดในรูปแบบอินเทอร์เน็ตบล็อกเชน!",
    "bz8": "2. Amazon Review RoBoT ทำงานอย่างไร",
    "bz9": "ความคิดเห็นรายวันจาก Amazon Review RoBoT แสดงให้เห็นว่าผลิตภัณฑ์ที่ต้องมีการปรับปรุงนั้นขายใน Amazon Review RoBoT ผู้ใช้เพียงแค่คลิกคำสั่งซื้ออย่างง่ายดาย และระบบจะสร้างการสมัครรับคำสั่งซื้อโดยอัตโนมัติ ผู้ใช้ชำระเงินตามจำนวนคำสั่งซื้อผ่าน blockchain USDT และรับค่าคอมมิชชั่นรายวัน",
    "bz10": "3.เหตุใดราคาในสกุลเงินเดียวกันจึงแตกต่างกันในการทำธุรกรรมสองรายการ?",
    "bz11": "ความแตกต่างของราคาเกิดจากปัจจัยทั้งหมดที่ไม่เอื้อต่อการหมุนเวียนของสกุลเงินอย่างเสรี รวมถึงความเร็วของการโอนสกุลเงิน เงื่อนไขของเครือข่าย ข้อจำกัดในการเข้าถึงสกุลเงิน การรับรู้สกุลเงินโดยผู้คนในภูมิภาคต่างๆ และแม้แต่ประเภทของคู่การซื้อขายที่ให้บริการโดยการแลกเปลี่ยน ธุรกรรม ฯลฯ ดังนั้น สกุลเงินเดียวกันจึงอาจมีความแตกต่างของราคาในธุรกรรมที่แตกต่างกัน",
    "bz12": "4. กำไรจากการลงทุน?",
    "bz13": "ยิ่งราคาของสินค้าที่คุณได้รับสูงเท่าไร กำไรที่คุณได้รับจากการสั่งซื้อก็จะยิ่งสูงขึ้นเท่านั้น ในเวลาเดียวกัน Amazon Review RoBoT จะสุ่มกระจายคำสั่งคอมมิชชันจำนวนมาก",
    "bz14": "ทุกๆ วัน ระบบจะสร้างและกระจายคำสั่งซื้อผลิตภัณฑ์ 60 รายการให้กับผู้ใช้โดยอัตโนมัติ ผู้ใช้ชำระเงินสำหรับแต่ละคำสั่งซื้อผ่าน USDT และรับค่าคอมมิชชัน 0.6% คำสั่งคอมมิชชั่นจำนวนมากจะถูกสุ่มมอบหมาย",
    "bz15": "USDT สามารถถอนออกได้หลังจาก 60 คำสั่ง (หากไม่ครบ 60 ออเดอร์ ระบบจะหยุดอัตโนมัติจนกว่าจะมีออเดอร์คงเหลือของวัน)",
    "bz16": "แต่ละบัญชีสามารถผูกกับบัญชี USDT ได้เพียงบัญชีเดียวเท่านั้น หากเกิดข้อผิดพลาดโปรดติดต่อฝ่ายบริการลูกค้า",
    "bz17": "หลังจากส่งคำสั่งซื้อรายวันเสร็จสิ้นแล้วคุณสามารถถอนเงินได้ตามปกติ เงินจะมาถึงภายใน 24 ชั่วโมงหลังจากเริ่มถอนเงิน และไม่มีข้อจำกัดในการถอนเงิน",
    "bz18": "ก่อนเติมเงิน โปรดผูกที่อยู่การถอนเงินของคุณ (รองรับ TRC-20) ที่อยู่ USDT คุณสามารถคลิกที่เติมเงินบนแอพหรือหน้าเว็บแล้วเลือกบล็อคเชน (TRC-20) ที่คุณใช้เติมเงิน",
    "bz19": "ไม่อนุญาตให้เติมเงินหรือโอนระหว่างบัญชีที่เกี่ยวข้องกัน นี่เป็นพฤติกรรมการแย่งคำสั่งที่เป็นอันตรายและส่งผลร้ายแรงต่อกฎการทำงานของแพลตฟอร์ม หากพบพฤติกรรมดังกล่าว ระบบจะระงับบัญชีและตัดสิทธิ์การทำงานทันที",
    "ty1": "ตกลง",
    "ty2": "ยกเลิก",
    "ty3": "ส่ง",
    "ty4": "ที่อยู่ TRC20",
    "ty5": "ที่อยู่ ERC20",
    "s1": "รายได้สะสม",
    "s2": "บริการ",
    "s3": "เกี่ยวกับเรา",
    "s4": "ช่วยด้วย",
    "s5": "พันธมิตร",
    "s6": "บริการของฉัน",
    "d1": "ไม่เสร็จ",
    "d2": "เสร็จสิ้น",
    "d3": "ยังไม่มีข้อมูล",
    "d4": "หมายเลขคำสั่งซื้อ",
    "d5": "ชั่วโมงการซื้อขาย",
    "d6": "จำนวน",
    "d7": "จำนวนงานปัจจุบัน",
    "d8": "ผลตอบแทนที่คาดหวัง",
    "d9": "ยังต้องการ",
    "d10": "เรตติ้ง",
    "j1": "ยอดเงินในบัญชี",
    "j2": "การแนะนำการซื้อขาย",
    "j3": "Amazon Review RoBoT ใช้คำติชมจาก Amazon Review RoBoT ทุกวันเพื่อแสดงผลิตภัณฑ์ที่ขายโดย Amazon Review RoBoT ที่ต้องมีการปรับปรุง ผู้ใช้เพียงแค่คลิกคำสั่งซื้อ จากนั้นระบบจะสร้างลายเซ็นคำสั่งซื้อโดยอัตโนมัติ ผู้ใช้ชำระเงินตามจำนวนคำสั่งซื้อผ่านบล็อกเชน USDT และสามารถรับค่าคอมมิชชันมากกว่า 0.6% ในแต่ละครั้ง และระบบจะสุ่มกระจายคำสั่งซื้อรางวัลจำนวนมาก",
    "j4": "เริ่มการจับคู่",
    "j5": "รายได้วันนี้",
    "j6": "เสร็จสิ้น",
    "j7": "จำนวนงานทั้งหมด",
    "td1": "ความสมดุล",
    "td2": "ค่าคอมมิชชัน",
    "td3": "รับ",
    "td4": "จำนวนคนทั้งหมด",
    "td5": "ผู้ใช้",
    "td6": "มีส่วนร่วม",
    "td7": "ปริมาณ",
    "td8": "สถานะ",
    "g1": "ถอนเงินสด",
    "g2": "เติมเงิน",
    "g3": "ชวนเพื่อน",
    "g4": "เชิญเลย",
    "g5": "สำหรับทุกๆ ผลกำไรที่เพื่อนของคุณได้รับหลังจากลงทะเบียน คุณจะได้รับค่าคอมมิชชั่นที่เกี่ยวข้อง",
    "g6": "ข้อมูลส่วนบุคคล",
    "g7": "รายละเอียดกองทุน",
    "g8": "บันทึกการเติมเงิน",
    "g9": "บันทึกการถอนเงิน",
    "g10": "ภาษา",
    "g11": "ออกจากระบบ",
    "g12": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?",
    "yh1": "ข้อมูลผู้ใช้",
    "yh2": "ปรับเปลี่ยน",
    "yh3": "การตั้งค่า",
    "yh4": "โทรศัพท์",
    "yh6": "รหัสผ่านเดิม",
    "yh7": "รหัสผ่านใหม่",
    "mx1": "การรวบรวมค่าคอมมิชชัน",
    "mx2": "รายได้",
    "mx3": "การถอนเงินถูกปฏิเสธ",
    "mx4": "เวลา",
    "mx5": "เติมเงินสำเร็จ",
    "mx6": "ถูกปฏิเสธ",
    "mx7": "รอดำเนินการ",
    "mx8": "ที่อยู่การถอนเงิน",
    "mx9": "ยอดคงเหลือที่มีอยู่",
    "mx10": "มาถึงจริง",
    "mx11": "กรุณากรอกจำนวนเงินที่ถอน",
    "cz1": "ที่อยู่การฝากเงินรองรับเฉพาะ ERC20 และจำนวนเงินฝากขั้นต่ำคือ 20USDT",
    "cz2": "คัดลอก",
    "cz3": "การเลือกสกุลเงินของ Fiat",
    "cz4": "จ่าย",
    "cz5": "ที่อยู่การฝากเงินรองรับเฉพาะ TRC20-USDT และจำนวนเงินฝากขั้นต่ำคือ 20USDT",
    "cz6": "ที่อยู่การฝากเงินรองรับเฉพาะ ERC20 และจำนวนเงินฝากขั้นต่ำคือ 20USDT",
    "qy1": "รหัสพื้นที่",
    "yq1": "ชวนเพื่อน",
    "yq2": "รหัสคำเชิญ",
    "yq3": "เชิญเพื่อนและเพลิดเพลินไปกับสิทธิประโยชน์มากมาย",
    "yq4": "ไปเชิญได้เลย",
    "zf1": "วิธีการเติมเงิน",
    "zf2": "โปรดเลือกวิธีการเติมเงิน",
    "zf3": "การซื้อขายสกุลเงิน",
    "zf4": "เครือข่ายการค้า",
    "zf5": "ไปค้าขาย",
    "zf6": "คัดลอกเรียบร้อยแล้ว",
    "zf7": "การซื้อขายสกุลเงิน",
    "zf8": "กรุณาใช้",
    "zf9": "โอนเงินไปยังที่อยู่ด้านล่างเพื่อทำการเติมเงินให้เสร็จสิ้น",
    "zf10": "สกุลเงินของธุรกรรม",
    "zf11": "คัดลอก",
    "zf12": "กรุณาตรวจสอบที่อยู่อย่างระมัดระวัง หากคุณโอนไม่ถูกต้อง คุณจะไม่สามารถเรียกคืนได้",
    "zf13": "เวลามาถึง",
    "zf14": "ประมาณ 1~5 นาที",
    "zf15": "จำนวนการเติมเงินขั้นต่ำ",
    "a1": "ศูนย์การตลาดร้านค้า",
    "a2": "ศูนย์การตลาดร้านค้า Amazon Market Robot เป็นส่วนใหม่ล่าสุดที่ออกแบบมาเพื่อช่วยให้ผู้ค้าเพิ่มยอดขายและอัตราการชมเชยผลิตภัณฑ์ของตนได้อย่างรวดเร็วในระยะเวลาอันสั้น ซึ่งจะช่วยเพิ่มน้ำหนักของผลิตภัณฑ์และเพิ่มการมองเห็นผลิตภัณฑ์ต่อไป ผู้ใช้ช่วยเหลือร้านค้าโดยทำภารกิจต่าง ๆ ให้สำเร็จและรับรางวัลที่เกี่ยวข้อง ดังนั้นจึงบรรลุสถานการณ์ที่ทั้งสองฝ่ายได้ประโยชน์ทั้งสองฝ่าย",
    "a3": "ปัจจุบัน ระบบมีผู้ใช้ 30 ล้านรายและผู้ค้า 5 ล้านราย และจำนวนผลิตภัณฑ์ที่โปรโมตบนแพลตฟอร์มทุกวันสูงถึง 70 ล้านราย สินค้าของร้านค้าบางรายเพิ่มยอดขายในร้านถึง 60% โดยเชื่อมต่อกับระบบศูนย์การตลาด และระบบศูนย์การตลาดเพียงคลิกคำสั่งซื้อ และระบบศูนย์การตลาดจะสร้างลายเซ็นคำสั่งซื้อโดยอัตโนมัติ หลังจากที่ผู้ใช้ชำระเงินตามจำนวนคำสั่งซื้อล่วงหน้า ธุรกรรมเสมือนจะเสร็จสมบูรณ์ และเงินจะถูกส่งคืนไปยังบัญชีผู้ใช้ทันที สามารถรับค่าคอมมิชชั่นเพิ่มเติมได้มากกว่า 0.6% ในแต่ละครั้ง ระบบจะสุ่มจัดสรรคำสั่งซื้อรางวัลจำนวนมากเพื่อเพิ่มค่าคอมมิชชั่นของผู้ใช้",
    "a4": "Amazon Market Robot ให้ความสำคัญอย่างยิ่งต่อความต้องการของผู้ใช้และผู้ค้า และยังคงเพิ่มประสิทธิภาพและปรับปรุงระบบศูนย์การตลาดอย่างต่อเนื่อง",
    // 客服
    "kf1": "บริการลูกค้าออนไลน์",
    "kf2": "บริการลูกค้าด้วยตนเองสำหรับการถอนเงิน",
    "kf3": "คุณสามารถคลิกที่นี่เพื่อติดต่อบริการลูกค้าด้วยตนเองสำหรับการถอนเงิน",
    "kf4": "บริการลูกค้าด้วยตนเองสำหรับการเติมเงิน",
    "kf5": "คุณสามารถคลิกที่นี่เพื่อติดต่อบริการลูกค้าด้วยตนเองสำหรับการเติมเงิน",
    // 支付选项弹窗
    "zf16": "การทำธุรกรรมด้วยบัตรธนาคาร กรุณาติดต่อฝ่ายบริการลูกค้า",
    "zf17": "ติดต่อฝ่ายบริการลูกค้า"
}
  